import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  select,
} from '@ngrx/store';
import { pipe } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { PhoneNumber } from 'src/app/models/auth/phone-number';
import { AllActionsUnion } from '../../../app.actions';
import {
  resetState,
  showMailConfirmModal,
  showUpdatePasswordSuccessModal,
  storeErrorMessage,
  storePhoneNumber,
  storeVeriricationId,
  updateLoading,
} from './account.actions';

export interface AccountState {
  verificationId: string;
  phoneNumber: PhoneNumber;
  showMailConfirmModal: boolean;
  showUpdatePasswordSuccessModal: boolean;
  loading: boolean;
  errorMessage: string;
}

const initialState: AccountState = {
  verificationId: '',
  phoneNumber: new PhoneNumber(''),
  showMailConfirmModal: false,
  showUpdatePasswordSuccessModal: false,
  loading: false,
  errorMessage: '',
};

export const featureName = 'accountFeature';

export function accountReducer(
  state_: AccountState | undefined,
  action: AllActionsUnion,
): AccountState {
  const reducer_ = createReducer<AccountState>(
    initialState,
    on(
      storeVeriricationId,
      (state, { payload }): AccountState => {
        return { ...state, verificationId: payload };
      },
    ),
    on(
      storePhoneNumber,
      (state, { payload }): AccountState => {
        return { ...state, phoneNumber: payload };
      },
    ),
    on(
      showMailConfirmModal,
      (state, { payload }): AccountState => {
        return { ...state, showMailConfirmModal: payload };
      },
    ),
    on(
      showUpdatePasswordSuccessModal,
      (state, { payload }): AccountState => {
        return { ...state, showUpdatePasswordSuccessModal: payload };
      },
    ),
    on(
      updateLoading,
      (state, { payload }): AccountState => {
        return { ...state, loading: payload };
      },
    ),
    on(
      storeErrorMessage,
      (state, { payload }): AccountState => {
        return { ...state, errorMessage: payload };
      },
    ),
    on(
      resetState,
      (): AccountState => {
        return { ...initialState };
      },
    ),
  );
  return reducer_(state_, action);
}

const getFeature = createFeatureSelector<AccountState>(featureName);

export const getVerificationId = pipe(
  select(
    createSelector(
      getFeature,
      v => v.verificationId,
    ),
  ),
);

export const getPhoneNumber = pipe(
  select(
    createSelector(
      getFeature,
      v => v.phoneNumber,
    ),
  ),
  filter(v => v.hasValue()),
);

export const getShowMailConfirmModal = pipe(
  select(
    createSelector(
      getFeature,
      v => v.showMailConfirmModal,
    ),
  ),
  distinctUntilChanged(),
);

export const getShowUpdatePasswordSuccessModal = pipe(
  select(
    createSelector(
      getFeature,
      v => v.showUpdatePasswordSuccessModal,
    ),
  ),
  distinctUntilChanged(),
);

export const getLoading = pipe(
  select(
    createSelector(
      getFeature,
      v => v.loading,
    ),
  ),
  distinctUntilChanged(),
);

export const getErrorMessage = pipe(
  select(
    createSelector(
      getFeature,
      v => v.errorMessage,
    ),
  ),
  distinctUntilChanged(),
);
